import { createAction, props } from '@ngrx/store';

import {
  Arrival,
  Cycle,
  Departure,
  Hatchery,
  Movement,
  Order,
  PropagationCompany,
  Section,
} from '../../models/cycle.model';

export const loadData = createAction('[Cycle] Load data');
export const loadCyclesRequest = createAction('[Cycle] Load cycles request');
export const loadCyclesSuccess = createAction(
  '[Cycle] Load cycles success',
  props<{ cycles: Cycle[] }>(),
);
export const loadCyclesFailed = createAction(
  '[Cycle] Load cycles failed',
  props<{ error: Error }>(),
);

export const upsertCycleRequest = createAction(
  '[Cycle] Upsert cycle request',
  props<{ cycle: Cycle }>(),
);
export const upsertCycleSuccess = createAction(
  '[Cycle] Upsert cycle success',
  props<{ cycle: Cycle }>(),
);
export const upsertCycleFailed = createAction(
  '[Cycle] Upsert cycle failed',
  props<{ error: Error }>(),
);

export const deleteCycleRequest = createAction(
  '[Cycle] Delete cycle request',
  props<{ cycle: Cycle }>(),
);
export const deleteCycleWithConfirmation = createAction(
  '[Cycle] Confirm Delete cycle',
  props<{ cycle: Cycle }>(),
);
export const deleteCycleSuccess = createAction(
  '[Cycle] Delete cycle success',
  props<{ cycle: Cycle }>(),
);
export const deleteCycleFailed = createAction(
  '[Cycle] Delete cycle failed',
  props<{ error: Error }>(),
);

export const createCycle = createAction('[Cycle] Create cycle', props<{ cycle: Cycle }>());

export const upsertCycleGeneral = createAction(
  '[Cycle] Upsert cycle general',
  props<{ cycle: Cycle }>(),
);

export const clearCycleState = createAction('[Cycle] Clears the cycle state');

/** ORDERS */
export const editOrder = createAction(
  '[Cycle] Edit order',
  props<{ cycleId: number; order: Order }>(),
);
export const addOrder = createAction(
  '[Cycle] Add order',
  props<{ cycleId: number; order: Order }>(),
);
export const deleteOrder = createAction(
  '[Cycle] Delete order',
  props<{ cycleId: number; id: number }>(),
);
export const deleteOrderWithConfirmation = createAction(
  '[Cycle] Confirm delete order',
  props<{ cycleId: number; id: number }>(),
);
export const setSelectedOrderId = createAction(
  '[Cycle] Set selected order id',
  props<{ id?: number }>(),
);

/** SECTIONS */
export const editSection = createAction(
  '[Cycle] Edit section',
  props<{ cycleId: number; section: Section }>(),
);
export const addSection = createAction(
  '[Cycle] Add section',
  props<{ cycleId: number; section: Section }>(),
);
export const deleteSection = createAction(
  '[Cycle] Delete section',
  props<{ cycleId: number; id: number }>(),
);
export const deleteSectionWithConfirmation = createAction(
  '[Cycle] Confirm delete section',
  props<{ cycleId: number; id: number }>(),
);
export const setSelectedSectionId = createAction(
  '[Cycle] Set selected section id',
  props<{ id?: number }>(),
);

export const loadPropagationCompaniesRequest = createAction(
  '[Cycle] Load Propagation Companies request',
);
export const loadPropagationCompaniesSuccess = createAction(
  '[Cycle] Load Propagation Companies success',
  props<{ propagationCompanies: PropagationCompany[] }>(),
);
export const loadPropagationCompaniesFailed = createAction(
  '[Cycle] Load Propagation Companies failed',
  props<{ error: Error }>(),
);

/** ARRIVALS */
export const editArrival = createAction(
  '[Cycle] Edit arrival',
  props<{ cycleId: number; arrival: Arrival }>(),
);
export const addArrival = createAction(
  '[Cycle] Add arrival',
  props<{ cycleId: number; arrival: Arrival }>(),
);
export const deleteArrival = createAction(
  '[Cycle] Delete arrival',
  props<{ cycleId: number; id: number }>(),
);
export const deleteArrivalWithConfirmation = createAction(
  '[Cycle] Confirm delete arrival',
  props<{ cycleId: number; id: number }>(),
);
export const setSelectedArrivalId = createAction(
  '[Cycle] Set selected arrival id',
  props<{ id?: number }>(),
);

/** MOVEMENTS */
export const editMovement = createAction(
  '[Cycle] Edit movement',
  props<{ cycleId: number; movement: Movement }>(),
);
export const addMovement = createAction(
  '[Cycle] Add movement',
  props<{ cycleId: number; movement: Movement }>(),
);
export const deleteMovement = createAction(
  '[Cycle] Delete movement',
  props<{ cycleId: number; id: number }>(),
);
export const deleteMovementWithConfirmation = createAction(
  '[Cycle] Confirm delete movement',
  props<{ cycleId: number; id: number }>(),
);
export const setSelectedMovementId = createAction(
  '[Cycle] Set selected movement id',
  props<{ id?: number }>(),
);

export const loadHatcheriesRequest = createAction('[Cycle] Load Hatcheries request');
export const loadHatcheriesSuccess = createAction(
  '[Cycle] Load Hatcheries success',
  props<{ hatcheries: Hatchery[] }>(),
);
export const loadHatcheriesFailed = createAction(
  '[Cycle] Load Hatcheries failed',
  props<{ error: Error }>(),
);

/** DEPARTURES */
export const editDeparture = createAction(
  '[Cycle] Edit departure',
  props<{ cycleId: number; departure: Departure }>(),
);
export const addDeparture = createAction(
  '[Cycle] Add departure',
  props<{ cycleId: number; departure: Departure }>(),
);
export const deleteDeparture = createAction(
  '[Cycle] Delete departure',
  props<{ cycleId: number; id: number }>(),
);
export const deleteDepartureWithConfirmation = createAction(
  '[Cycle] Confirm delete departure',
  props<{ cycleId: number; id: number }>(),
);
export const setSelectedDepartureId = createAction(
  '[Cycle] Set selected departure id',
  props<{ id?: number }>(),
);
